module.exports = __webpack_public_path__ + "static/media/heart2.c729caf9.svg";